import { render, staticRenderFns } from "./buy-team.vue?vue&type=template&id=9935372c&"
import script from "./buy-team.vue?vue&type=script&lang=js&"
export * from "./buy-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports